import ElevatedSvg from './elevated-svg';

type MaxBadgeSize = 'md' | 'lg';

interface IDocumentsIconProps {
    maxBadgeSize: MaxBadgeSize;
}

const DocumentsIcon = ({ maxBadgeSize }: IDocumentsIconProps) => {
    const widthValue = maxBadgeSize === 'lg' ? '5rem' : '4rem';

    return (
        <ElevatedSvg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80 90"
            sx={{ width: { md: widthValue }, borderRadius: 1 }}
        >
            <path
                fill="#fff"
                d="M0,25.6c0-8.96,0-13.44,1.74-16.86,1.53-3.01,3.98-5.46,6.99-6.99,3.42-1.74,7.9-1.74,16.86-1.74h28.8c8.96,0,13.44,0,16.86,1.74,3.01,1.53,5.46,3.98,6.99,6.99,1.74,3.42,1.74,7.9,1.74,16.86v38.8c0,8.96,0,13.44-1.74,16.86-1.53,3.01-3.98,5.46-6.99,6.99-3.42,1.74-7.9,1.74-16.86,1.74h-28.8c-8.96,0-13.44,0-16.86-1.74-3.01-1.53-5.46-3.98-6.99-6.99-1.74-3.42-1.74-7.9-1.74-16.86V25.6Z"
            />
            <path
                fill="#0a0"
                d="M47.03,25.38c-.52-.53-1.06-1.09-1.27-1.61-.2-.5-.22-1.27-.23-2.02-.03-1.28-.06-2.75-1.05-3.73-1.03-1.02-2.52-1.05-3.83-1.06-.72-.02-1.47-.03-1.94-.22-.45-.19-.98-.7-1.52-1.22-.94-.91-2-1.94-3.45-1.94s-2.44,1-3.38,1.89c-.53.52-1.09,1.06-1.61,1.27-.5.2-1.27.22-2.02.23-1.28.03-2.75.06-3.73,1.05-1.02,1.03-1.05,2.52-1.06,3.83-.02.72-.03,1.47-.22,1.94-.19.45-.7.98-1.22,1.52-.91.94-1.94,2-1.94,3.45s1,2.44,1.89,3.38c.52.53,1.06,1.09,1.27,1.61.2.5.22,1.27.23,2.02.03,1.28.06,2.75,1.05,3.73,1.03,1.02,2.52,1.05,3.83,1.06.72.02,1.47.03,1.92.22.47.19,1,.7,1.53,1.22.94.91,2,1.94,3.45,1.94s2.44-1,3.38-1.89c.53-.52,1.09-1.06,1.61-1.27.5-.2,1.27-.22,2.02-.23,1.28-.03,2.75-.06,3.73-1.05,1.02-1.03,1.05-2.52,1.06-3.83.02-.72.03-1.47.22-1.94.19-.45.7-.98,1.22-1.52.91-.94,1.94-2,1.94-3.45s-1-2.44-1.89-3.38ZM39.38,24.66l-6.03,9.38c-.19.3-.52.48-.86.52h-.08c-.33,0-.64-.14-.84-.41l-3.36-4.02c-.39-.47-.33-1.17.16-1.56.47-.39,1.16-.33,1.56.14l2.38,2.86,5.2-8.09c.33-.52,1.02-.67,1.53-.34.52.34.67,1.02.34,1.53Z"
            />
            <path
                fill="#ccd0d6"
                d="M16.82,52.95h45.45c1,0,1.82.81,1.82,1.82h0c0,1-.81,1.82-1.82,1.82H16.82c-1,0-1.82-.81-1.82-1.82h0c0-1,.81-1.82,1.82-1.82Z"
            />
            <path
                fill="#ccd0d6"
                d="M16.82,61.51h45.45c1,0,1.82.81,1.82,1.82h0c0,1-.81,1.82-1.82,1.82H16.82c-1,0-1.82-.81-1.82-1.82h0c0-1,.81-1.82,1.82-1.82Z"
            />
            <rect fill="#ccd0d6" x="15" y="70.07" width="35.45" height="3.64" rx="1.82" ry="1.82" />
        </ElevatedSvg>
    );
};

export default DocumentsIcon;
